import React, { useState } from 'react';
import Header from './Header';
import { Button,Modal } from 'react-bootstrap';
function SpiceClub() {
    const [show, setShow] = useState(false);
    const [AddBags, setAddBags] = useState([ ]);

   function fncBagsAdd(e)
    {
         
        console.log(e);
        var noOfBags = e.target.value;
        var bagsArray = [];
        for(var i=0 ;i<noOfBags; i++)
        {   
            bagsArray[i]= {   
                        no: i,
                        weight:'',
                        bagType:''
                    }
        }
  

    // let newArr = [...AddBags]; // copying the old datas array
    // newArr[0] = e.target.value; // replace e.target.value with whatever you want to change it to
    setAddBags(bagsArray); // ??

    console.log(AddBags)

    }
  return (
    <div className="container">

                    <div className="box-white-shadow rounded mt-20">
                      <div class="row">
                                <div class="col-12 sp-red-box-details">
                                    <div class="card">
                                        <div class="card-header d-flex justify-content-between px-3">
                                            <span><strong>SpiceClub</strong></span>
                                            <strong>SC Points Balance: 8000</strong>
                                        </div>
                                        <div class="card-body p-3">
                                            <div class="row">                                                        
                                                <div class="col-12 col-lg-5 mb-3 mb-lg-0">
                                                    <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">Member Name</div>
                                                    <div class="d-block w-100 sp-ulist-data">Chang, Lyna Mrs.</div>
                                                </div>
                                                <div class="col-12 col-lg-3 mb-3 mb-lg-0">
                                                    <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">Club Type</div>
                                                    <div class="d-block w-100 sp-ulist-data">Clasic</div>
                                                </div>
                                                <div class="col-12 col-lg-4 text-lg-right">
                                                    <div class="d-block w-100 text-uppercase text-color-black font-semiBold pb-1">Contact No.</div>
                                                    <div class="d-block w-100 sp-ulist-data">+91-8447325114</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>


                                
                                </div>


      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
           
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <div className="row">  
            <div className="col-6">Passengers</div>
            <div className="col-6">Chang, Lyna Mrs</div>
            <div className="col-6">Destination</div>
            <div className="col-6">
            <select>
                <option>Mumbai (BOM)</option>
                <option>Mumbai (BOM)</option>
                <option>Mumbai (BOM)</option>
                <option>Mumbai (BOM)</option>
                </select>
            </div>
            <div className="col-6">Bags to Add</div>
            <div className="col-6">
                <select  onChange={e => fncBagsAdd(e)}>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                </select>
                </div>
            <div className="col-4">Bag 1:</div>
            <div className="col-4"><input type="text" style={{"width":"80%"}} /> Kg</div>
            <div className="col-4">
            <select>
                <option> STND </option>
                <option> STND </option>
                <option> STND </option>
                <option> STND </option>
                </select>

            </div>
            <div className="col-4">Bag 1:</div>
            <div className="col-4"><input type="text" style={{"width":"80%"}}  /> Kg</div>
            <div className="col-4">
            <select>
                <option> STND </option>
                <option> STND </option>
                <option> STND </option>
                <option> STND </option>
                </select>

            </div>
            <div className="col-12" style={{"margin":"10px"}}></div>
            <div className="col-6"></div>
            <div className="col-6 text-right">
                <button className="btn btn-primary">Add</button> 
                <button className="btn btn-danger" style={{"marginLeft":"5px"}}>Cancel</button>
            </div>

         </div>
        </Modal.Body>
      </Modal>

    </div>
  );
}

export default SpiceClub;